interface TransfereFacilIconProps {
  className?: string
}

const TransfereFacilIcon = ({ className }: TransfereFacilIconProps) => {
  return (
    <svg
      width="38"
      height="40"
      viewBox="0 0 38 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M29.4266 40H7.77226H2.12584C1.15361 40 0.112513 39.0773 0.112513 37.6614L0.112513 29.5575C0.112513 21.4156 -0.359178 21.2074 7.24195 21.2074H18.1133C18.732 21.2074 16.1689 25.4867 14.8431 27.9646C13.5173 30.4425 16.434 32.6549 18.1133 31.2389C19.7927 29.823 28.2776 22.6549 29.3382 21.7699C30.3989 20.885 30.7524 19.5575 29.3382 18.4071C27.9241 17.2566 19.3507 10.177 17.8482 8.76106C16.3456 7.34513 13.4289 9.02655 14.5779 11.1504C15.7269 13.2743 18.8204 17.5509 18.1133 17.5509H7.24196C-2.03848 17.5509 -2.78235 0 7.24195 0H35.9671C37.4697 0 38 1.06195 38 2.56637V31.5044C38 35.6637 33.3156 40 29.4266 40Z"
        fill="white"
      />
    </svg>
  )
}

export default TransfereFacilIcon